import { isFedRamp } from '@atlassian/atl-context';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { fg } from '@confluence/feature-gating';

export const isContentTypeEnabledInCurrentEnv = (
	contentType: 'whiteboard' | 'database' | null | undefined,
): boolean => {
	if (contentType === 'database' || contentType === 'whiteboard') {
		// Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
		if (fg('use_frontend_feature_encoding_sdk')) {
			const featureKey =
				contentType === 'database' ? 'confluence-databases' : 'confluence-whiteboards';
			return isFeatureEnabled('confluence', featureKey);
		}
		return !isFedRamp();
	}

	return true;
};
